import { createFileRoute } from '@tanstack/react-router';
import { ResourcesPage } from '@/features/resources/components/ResourcesPage';

export const Route = createFileRoute('/_app/resources')({
  component: ResourcesPage,
});
